<template>
  <div class="">
    <top-header :type="6" :hasBorder="true" :placeholder="'房源核验'" :bgColor="'#fff'" fontSize="0.32rem"/>
    <div class="top_banner">
      <img src="@/assets/img/axxf.png" alt="">
    </div>
    <div class="check_box">
      <input type="text" v-model="code" placeholder="输入房源核验编码..." name="" id="">
      <button @click="check">核验</button>
    </div>
    <van-overlay class="flex_v flex_hc flex_vc" :show="showCover" @click="showCover = false" z-index="9">
      <div class="check_con" @click.stop>
        <div class="check_top m_flex_box flex_vc flex_hc" :class="detail.cf === 1 && detail.dy === 1 ? 'error' :  (detail.cf === 1 || detail.dy === 1 ? 'warning' : 'success')">
          <img src="@/assets/img/yz.png" alt="">
          <div>
            <h5>{{msg}}</h5>
            <p>{{detail.info}}</p>
          </div>
        </div>
        <div class="check_bottom">
          <p>{{detail.detail}}</p>
          <div class="btn" :class="detail.cf === 1 && detail.dy === 1 ? 'error' :  (detail.cf === 1 || detail.dy === 1 ? 'warning' : 'success')" @click="closeCover">确定</div>
        </div>
      </div>
    </van-overlay>
    <slide-img></slide-img>
  </div>
</template>

<script>
import qs from 'qs'
import topHeader from '@/components/header'
import slideImg from '@/components/slideImg'
export default {
  data() {
    return {
      code: '',
      showCover: false,
      msg: '',
      detail: ''
    };
  },
  components: {
    topHeader,
    slideImg
  },
  mounted() {
    var Img=this.logoImg
    var url = window.location.href;
    var hosts = url.split('/#/')[0];//获取域名加打包文件夹名称
    var shareImg = hosts.concat('/'+Img);
    this.$share('徐州市房地产信息网房源核验','安心选房 真实出售 全网真房源 找房新体验',shareImg)
    if(this.$route.query.uniqueCode){
      this.code=this.$route.query.uniqueCode
      this.check()
    }
  },
  methods: {
    closeCover() {
      this.showCover = false;
    },
    check() {
      if (!this.code) {
        this.$toast('请输入房源核验编码');
        return;
      }
      //房源核验
      this.$http.post('cms/houseListed/permit/searchUniqueCode.do', qs.stringify({
        uniqueCode: this.code,
      })).then(res => {
        this.loading = false;
        if (res.success) {
          this.$set(this, 'detail', res.obj);
          this.$set(this, 'msg', res.msg);
          this.showCover = true;
        } else {
          this.$toast(res.msg);
        }
      })
    }
  },
};
</script>
<style lang="less" scoped>
  .top_banner {
    img{
      width: 100%;
      height: 2.9rem;
      display: block;
    }
  }
  .check_box{
    padding: 0.8rem 0 0;
    width: 7.04rem;
    margin: 0 auto;
    input{
      display: block;
      text-align: center;
      width: 100%;
      height: 1.04rem;
      background-color: #F4F4F4;
      margin-bottom: 0.38rem;
      font-size: 0.3rem;
      border-radius: 0.08rem;
    }
    button{
      font-size: 0.28rem;
      width: 100%;
      height: 0.74rem;
      background-color: #2F72F5;
      border-radius: 0.08rem;
      color: #fff;
    }
  }
  .check_con{
    background-color: #fff;
    width: 6.64rem;
    border-radius: 0.12rem;
    overflow: hidden;
    .check_top{
      height: 2.16rem;
      color: #fff;
      img{
        width: 0.74rem;
        margin-right: 0.44rem;
      }
      h5{
        font-size: 0.38rem;
        font-weight: 800;
        margin-bottom: 0.07rem;
      }
      p{
        font-size: 0.3rem;
      }
      &.success{
        background-color: #17C5FB;
      }
      &.warning{
        background-color: #FF9832;
      }
      &.error{
        background-color: #ee2424;
      }
    }
    .check_bottom{
      box-sizing: border-box;
      padding: 0.3rem 0.6rem;
      p{
        height: 3rem;
        overflow: auto;
        font-size: 0.28rem;
        line-height: 0.52rem;
      }
    }
    .btn{
      font-size: 0.28rem;
      text-align: center;
      //background-color: #17C5FB;
      &.success{
        background-color: #17C5FB;
      }
      &.warning{
        background-color: #FF9832;
      }
      &.error{
        background-color: #ee2424;
      }
      color: #fff;
      line-height: 0.82rem;
      border-radius: 0.08rem;
    }
  }
</style>